<template>
  <div class="page-container">
    <common-header></common-header>
    <div class="page-content-container">
      <siderbar></siderbar>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import '@/assets/js/bootstrap.min.js'
import '@/assets/js/nifty.min.js'
import '@/assets/plugins/chosen/chosen.jquery.min.js'

import CommonHeader from './header'
import Siderbar from './sider'
export default {
  components: {
    CommonHeader,
    Siderbar,
  },
}
</script>

<style>
/* @import '../plugins/chosen/chosen.css'; */
</style>

<style scoped>
.page-container {
  height: 100vh;
  min-height: 100vh;
  min-width: 100%;
  width: 100%;
  flex-direction: column;
  box-sizing: border-box;
  display: flex;
}

.page-content-container {
  display: flex;
  height: calc(100% - 110px);
}
</style>

